<template>
  <div>
    <el-table :data="gasList" size="small" border>
      <!-- <el-table-column prop="id" width="140px" label="ID" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
         
        </template>
      </el-table-column> -->
      <el-table-column prop="id" label="id" fixed>
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>
      <el-table-column prop="module" label="模块" fixed>
        <template slot-scope="scope">
          <span v-if="scope.row.module">{{ scope.row.module }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>

      <el-table-column prop="contentEn" label="英文">
        <template slot-scope="scope">
          <span>{{ scope.row.contentEn }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contentZh" label="中文">
        <template slot-scope="scope">
          <span>{{ scope.row.contentZh }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="开始时间">
        <template slot-scope="scope">
          <span>{{ scope.row.startTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="endTime" label="结束时间">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isOpen" label="开关">
        <template slot-scope="scope">
          
          <el-switch :value="scope.row.isOpen" @change="mirrorBargainSwitch($event,scope.row)"></el-switch>

        </template>
      </el-table-column>

      <el-table-column label="编辑" fixed="right" width="120" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(scope.row)"
          ></el-button>
          <!-- <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="handleDel(scope.row)"
          ></el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="size"
      :total="totalCount"
      :page="page"
      @pageChanged="pageChanged"
    ></pagination>
    <update-dialog
      :val="userinfoDetail"
      :selected="queryValue"
      :page="page"
      :size="size"
    ></update-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";
import updateDialog from "../updatedialog";

export default {
  name: "GasList",
  props: ["queryValue"],
  data() {
    return {
      page: 1,
      size: 25,
    };
  },
  components: {
    Pagination,
    updateDialog,
  },
  methods: {
    ...mapActions("maintenance", ["updateDividendStatus", "updateSwitch"]),
    ...mapMutations("maintenance", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",'setPagination'
    ]),
    pageChanged(e) {
      this.page = e.page;
      this.size = e.size;
      this.setPagination(e)
      this.$emit("refresh", { page: this.page, size: this.size });
    },
    handleDel(row) {
      console.log(row);
    },
    handleUpdate(selected) {
      this.setUserinfoDetail(selected);
      this.setUserinfoDetailDialogVisible(true);
    },
    mirrorBargainSwitch(e,row){
      console.log('row',row,e);
      this.$confirm('确定修改配置开关?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const res=await  this.updateSwitch({id:row.id})
        if(res.code==0){
          // this.mirrorBargainStatus=e
          this.$emit("refresh",this.pagination)
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
        }
        
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    },
  },
  computed: {
    ...mapGetters("maintenance", ["userList"]),
    ...mapState("maintenance", [
      "pagination",
      "totalCount",
      "userinfoDetail",
      "userinfoDetailDialogVisible",
      "blockInfoList",
      "gasList",
    ]),
  },
};
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: red;
  font-weight: bold;
}
</style>
